const translations = {
  header: "Post from {name}",
  notFound: "Post not found",
  title: "Community post"
};

export default translations;
